import { createSlice } from "@reduxjs/toolkit";
import { getAllServices, getAllServiceproviders } from "./thunk"; // Import the async thunks

const initialState = {
  Services: [],
  Serviceproviders: [],
  loading: false,
  isLoading: false,
  error: null,
  isError: null,
};

const ServicesSlice = createSlice({
  name: "ServicesSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle getAllServices
      .addCase(getAllServices.pending, (state) => {
        state.loading = true;
        state.Services = []
      })
      .addCase(getAllServices.fulfilled, (state, action) => {
        state.loading = false;
        state.Services = action.payload; // Save the Services payload
      })
      .addCase(getAllServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(getAllServiceproviders.pending, (state) => {
        state.isLoading = true;
        state.Serviceproviders = []
      })
      .addCase(getAllServiceproviders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.Serviceproviders = action.payload;
      })
      .addCase(getAllServiceproviders.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = action.error.message;
      });
  },
});

export default ServicesSlice.reducer;
